export const ThriventBankModalText = () => {
  return (
    <>
      <div>
        You are now leaving the Thrivent website. Deposit and lending services
        are offered by Thrivent Bank, a Utah-chartered industrial bank, Member
        FDIC. Insurance, securities, investment advisory and trust and
        investment management accounts and services offered by Thrivent, the
        marketing name for Thrivent Financial for Lutherans, or its affiliates
        are not deposits or obligations of Thrivent Bank, are not guaranteed by
        Thrivent Bank, are not insured by the FDIC, and involve investment risk,
        including possible loss of the principal amount invested.
      </div>

      <div>
        Any data or personal information collected by websites other than
        Thrivent is not covered by Thrivent privacy policy. We recommend you
        read the privacy policies of those sites as they may be different from
        Thrivent policy.
      </div>
      <div style={{ textAlign: 'right' }}>7938310.1</div>
    </>
  );
};
